const { getValueFromEnv } = require('@tekion/tap-components/utils/commonHelper');
const { default: TokenManager } = require('@tekion/tap-components/utils/TokenManager');

const BASE_URL = getValueFromEnv('BASE_URL');
const COGNITO_API_VERSION = TokenManager.getItem(TokenManager.cognitoApiVersionKey);

const getApiBaseRoute = () => TokenManager.getItem(TokenManager.cognitoApiBaseRouteKey) || 'tapapi';

module.exports = {
  getUserProfile: `/${getApiBaseRoute()}/v2/usermanagement/getuserprofile`,
  updateUserProfile: `/${getApiBaseRoute()}/v2/usermanagement/updateuserprofile`,
  getUserPreference: `/${getApiBaseRoute()}/task_management/public/v1/users/me`,
  getTmUsers: `/${getApiBaseRoute()}/task_management/public/v1/users`,
  getTmTranslateUsers: `/${getApiBaseRoute()}/task_management/public/v1/users/translate`,
  editTmUserRole: `/${getApiBaseRoute()}/task_management/public/v1/users/permission`,
  postUpdateNotification: `/${getApiBaseRoute()}/iotIncidentManagement/v1/public/updateNotification`,
  postUpdateSummary: `/${getApiBaseRoute()}/task_management/public/v1/users/preference`,
  getUserAvailable: `/${getApiBaseRoute()}/tap_calendar/internal/user`,
  storeUserAvailable: `/${getApiBaseRoute()}/tap_calendar/internal/user/settings`,
  getListing: `/${getApiBaseRoute()}/v2/common/{feature}/list`,
  saveModule: `/${getApiBaseRoute()}/v2/common/tapfeature/version`,
  fetchModule: `/${getApiBaseRoute()}/v2/common/{feature}/{module}/version`,
  releaseVersion: `/${getApiBaseRoute()}/v2/common/releasenotes/TAP/{version}`,
  getUserRole: `/${getApiBaseRoute()}/v2/usermanagement/getuserrole`,
  /** Support Portal urls */
  getUserGroups: `/${getApiBaseRoute()}/${TokenManager.shouldUsePlatformApis ? 'userservice' : 'helpdesk'}/v1/public/groups/filter`,
  updateNotifyInUserGroups: `/${getApiBaseRoute()}/${TokenManager.shouldUsePlatformApis ? 'userservice' : 'helpdesk'}/v1/public/groups/<group_id>`,
  /** Cards Management Urls */
  getAllCards: `/${getApiBaseRoute()}/v2/cardmanagement/cards`,
  getIndividualCard: `/${getApiBaseRoute()}/v2/cardmanagement/card/{appKey}`,
  addCard: `/${getApiBaseRoute()}/v2/cardmanagement/addcard`,
  deleteCard: `/${getApiBaseRoute()}/v2/cardmanagement/deletecard`,
  updateCard: `/${getApiBaseRoute()}/v2/cardmanagement/updatecard`,

  getAllCardsNew: `/${getApiBaseRoute()}/user-service/${COGNITO_API_VERSION}/public/application`,
  addCardNew: `/${getApiBaseRoute()}/user-service/${COGNITO_API_VERSION}/public/application/create`,
  getIndividualCardNew: `/${getApiBaseRoute()}/user-service/${COGNITO_API_VERSION}/public/application/get/{appKey}`,
  deleteCardNew: `/${getApiBaseRoute()}/user-service/${COGNITO_API_VERSION}/public/application/{appKey}`,
  updateCardNew: `/${getApiBaseRoute()}/user-service/${COGNITO_API_VERSION}/public/application/{appKey}`,

  /** Group Management Urls */
  getAllGroups: `/${getApiBaseRoute()}/v2/groupmanagement/groups`,
  getIndividualGroup: `/${getApiBaseRoute()}/v2/groupmanagement/group/{groupKey}`,
  createGroup: `/${getApiBaseRoute()}/v2/groupmanagement/addGroup`,
  updateGroup: `/${getApiBaseRoute()}/v2/groupmanagement/updateGroup`,
  deleteGroup: `/${getApiBaseRoute()}/v2/groupmanagement/deleteGroup`,
  groupTypes: `/${getApiBaseRoute()}/v2/groupmanagement/groupTypes`,

  getAllGroupsNew: `/${getApiBaseRoute()}/user-service/${COGNITO_API_VERSION}/public/group`,
  getIndividualGroupNew: `/${getApiBaseRoute()}/user-service/${COGNITO_API_VERSION}/public/group/get/{groupKey}`,
  createGroupNew: `/${getApiBaseRoute()}/user-service/${COGNITO_API_VERSION}/public/group/create`,
  updateGroupNew: `/${getApiBaseRoute()}/user-service/${COGNITO_API_VERSION}/public/group/{groupKey}`,
  deleteGroupNew: `/${getApiBaseRoute()}/user-service/${COGNITO_API_VERSION}/public/group/{groupKey}`,
  groupTypesNew: `/${getApiBaseRoute()}/user-service/${COGNITO_API_VERSION}/public/groupType`,
  authenticateOKTAUser: `${BASE_URL}/${getApiBaseRoute()}/user-service/${COGNITO_API_VERSION}/public/users/upsertUser`,

  /** Tap Configurations Page urls */
  getTapConfig: `/${getApiBaseRoute()}/v2/common/tapconfigurations`,

  /** User Management Urls */
  getAllUsers: `/${getApiBaseRoute()}/v2/core/user-mgmt/list`,
  searchUsers: `/${getApiBaseRoute()}/v2/core/user-mgmt/search?query=`,
  createUser: `/${getApiBaseRoute()}/v2/restricted/user/create`,
  deleteUser: `/${getApiBaseRoute()}/v2/restricted/user/delete`,
  getUserAvailability: `/${getApiBaseRoute()}/tap_calendar/internal/user/availability`,
  updateUserAvailability: `/${getApiBaseRoute()}/tap_calendar/internal/user/availability/{uuid}`,

  // notification settings urls
  GetUserDetails: `/${getApiBaseRoute()}/user-service/v1/public/userPreference/me`,
  updateUserPreference: `/${getApiBaseRoute()}/user-service/v1/public/userPreference`,
  /** Mobile Configurations */
  fetchMobileConfig: `${BASE_URL}/${getApiBaseRoute()}/v2/common/mobileconfig/all`,
  updateMobileConfig: `${BASE_URL}/${getApiBaseRoute()}/v2/common/mobileconfig/{platform}`,
  getMobileConfig: `${BASE_URL}/${getApiBaseRoute()}/v2/common/mobileconfig/get/{platform}`,

  // Feature Tracker
  getAllBoards: `/${getApiBaseRoute()}/global-feature-tracker/v1/public/boards/getAll?pageType=side_nav`,
  getFTUserPreference: `/${getApiBaseRoute()}/global-feature-tracker/v1/public/users/me`,
  putUserPreference: `/${getApiBaseRoute()}/global-feature-tracker/v1/public/users/userPreference`,
};
